"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import React from "react";
import TextDroppableInput from "../text_droppable_input";
import CustomerTypeAhead from "../customer_typeahead";
import LookupAddressApi from "../../api/lookup_address";
const LOADING = "Loading...";
const NO_RESULTS_FOUND = "No results found.";
const viewFields = ({
  props,
  state: {
    form,
    isShowingAddress,
    matches,
    errors,
    errorMessages,
    selectedCustomer
  },
  actions: {
    update,
    lookupAddressById,
    fillAddress,
    toggle,
    blur,
    updateCustomer
  }
}) => {
  const labelledField = (inputFn) => (field) => {
    const { key, width, label, required } = field;
    return /* @__PURE__ */ React.createElement(
      "label",
      {
        className: "form__input" + (width ? ` form__input--${width}` : "")
      },
      /* @__PURE__ */ React.createElement("span", null, label),
      required ? /* @__PURE__ */ React.createElement("span", { className: "form__optional" }, /* @__PURE__ */ React.createElement("span", { className: "show_for_non_reskin" }, " \u2013 "), "required") : "",
      /* @__PURE__ */ React.createElement("div", { className: "form__error" }, errorMessages[key]),
      inputFn(field)
    );
  };
  const input = (type) => labelledField(({ key, required }) => {
    const value = type === "date" && form[key] ? form[key].split("T")[0] : form[key];
    return /* @__PURE__ */ React.createElement(
      TextDroppableInput,
      {
        type,
        name: key,
        required,
        value,
        className: errors[key] || errorMessages[key] ? "form__error" : "",
        onDrop: update(key),
        onChange: update(key),
        onBlur: blur({ key, required })
      }
    );
  });
  const viewSelect = (field) => {
    const { key, options, required } = field;
    const option_tags = [];
    if (Array.isArray(options)) {
      option_tags.push(
        ...options.map((option, i) => /* @__PURE__ */ React.createElement("option", { key: i, value: option }, option))
      );
    } else {
      option_tags.push(
        ...Object.keys(options).map((key2) => /* @__PURE__ */ React.createElement("option", { key: key2, value: key2 }, options[key2]))
      );
    }
    return /* @__PURE__ */ React.createElement(
      "select",
      {
        name: key,
        value: form[key] || field["default"],
        onChange: update(key),
        className: errors[key] ? "form__error" : "",
        onBlur: blur({ key, required })
      },
      !required && !field["default"] ? /* @__PURE__ */ React.createElement("option", { value: "" }, "Select an option") : "",
      option_tags
    );
  };
  const lookup = (field) => {
    const { fieldKey } = field;
    const match = matches[fieldKey];
    const message = typeof match === "string" ? match : void 0;
    let content = "";
    if (message) {
      content = /* @__PURE__ */ React.createElement("p", null, message);
    } else if (match) {
      content = /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("a", { onClick: fillAddress(fieldKey, match) }, 'Select "', match.address.name, '"'));
    }
    return /* @__PURE__ */ React.createElement("div", null, labelledField(({ key }) => /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "search",
        value: form[key],
        onChange: lookupAddressById(fieldKey)
      }
    ))(field), content);
  };
  const fields = {
    text: input("text"),
    date: input("date"),
    lookup,
    select: labelledField(viewSelect),
    row({ fields: fields2 }) {
      return /* @__PURE__ */ React.createElement("div", { className: "form__row" }, fields2.map(viewField));
    }
  };
  fields.address = ({ key, labels, required }) => {
    return /* @__PURE__ */ React.createElement("div", { className: "form" }, addressFields(key, labels, required).map(viewField));
  };
  fields.labeledAddress = (field) => {
    return /* @__PURE__ */ React.createElement("fieldset", { className: "form__fieldset" }, /* @__PURE__ */ React.createElement("div", { className: "form__legend-wrapper" }, /* @__PURE__ */ React.createElement("legend", { className: "form__legend" }, field.label)), fields.address(field));
  };
  fields.lookupAddress = (field) => {
    const { key, label, required } = field;
    const toggleLabel = isShowingAddress[key] ? "Lookup by ID" : "Enter manually";
    const content = isShowingAddress[key] ? fields.address(field) : fields.lookup({
      fieldKey: key,
      key: `${key}_lookup`,
      label: "Lookup by ID"
    });
    return /* @__PURE__ */ React.createElement("fieldset", { className: "form__fieldset" }, /* @__PURE__ */ React.createElement("div", { className: "form__legend-wrapper" }, /* @__PURE__ */ React.createElement("legend", { className: "form__legend" }, label, required ? /* @__PURE__ */ React.createElement("span", { className: "form__optional" }, /* @__PURE__ */ React.createElement("span", { className: "show_for_non_reskin" }, " \u2013 "), " required") : ""), /* @__PURE__ */ React.createElement("a", { className: "form__toggle", onClick: toggle(field) }, toggleLabel)), content);
  };
  fields.customerPicker = labelledField(({ key }) => /* @__PURE__ */ React.createElement(
    CustomerTypeAhead,
    {
      customer: selectedCustomer,
      onSelectCustomer: updateCustomer(key),
      onClearCustomer: updateCustomer(key)
    }
  ));
  const viewField = (field, i) => {
    const view = fields[field.type];
    return view ? /* @__PURE__ */ React.createElement("div", { className: "form__field", key: i }, view(field)) : console.warn("WARN", `Unrecognized type ${field.type} provided...`);
  };
  return props.fields.map(viewField);
};
const addressFields = (key, labels = {}, required) => [
  {
    type: "text",
    key: `${key}_name`,
    label: labels.name || "Name",
    width: "large",
    required
  },
  {
    type: "row",
    fields: [
      {
        type: "text",
        key: `${key}_address_line_1`,
        label: labels.address_line_1 || "Address Line 1",
        width: "medium",
        required
      },
      {
        type: "text",
        key: `${key}_address_line_2`,
        label: labels.address_line_2 || "Address Line 2"
      }
    ]
  },
  {
    type: "row",
    fields: [
      {
        type: "text",
        key: `${key}_city`,
        label: labels.city || "City",
        required
      },
      {
        type: "text",
        key: `${key}_state`,
        label: labels.state || "State",
        width: "small",
        required
      },
      {
        type: "text",
        key: `${key}_postal_code`,
        label: labels.postal_code || "Postal Code",
        required
      }
    ]
  }
];
const requiredFieldMapping = (fields) => {
  const reducer = (obj, field) => subFields(field) ? __spreadValues(__spreadValues({}, obj), subFields(field).reduce(reducer, {})) : __spreadProps(__spreadValues({}, obj), { [field.key]: field.required || false });
  return reducer({}, { fields });
};
const subFields = ({ key, labels, fields, type, required }) => {
  switch (type) {
    case "labeledAddress":
    case "lookupAddress":
      return addressFields(key, labels, required);
    default:
      return fields ? fields : void 0;
  }
};
const isMissingRequiredFields = ({ fields, data }) => Object.entries(requiredFieldMapping(fields)).some(
  ([key, isRequired]) => isRequired && !data[key]
);
export default React.createClass({
  getInitialState() {
    return {
      form: __spreadValues({}, this.props.form),
      selectedCustomer: this.props.customer,
      errors: {},
      errorMessages: {},
      isShowingAddress: {},
      matches: {}
    };
  },
  componentDidMount() {
    this.formWasUpdated(this.state.form);
  },
  formWasUpdated(form) {
    const hasErrors = isMissingRequiredFields({
      fields: this.props.fields,
      data: form
    });
    this.props.onFormUpdate(hasErrors, form, this.setErrorMessages);
  },
  setErrorMessages(errors) {
    this.state.errorMessages = errors;
    this.setState(this.state);
  },
  update(key) {
    return (e, value) => {
      this.state.form[key] = value || e.target.value;
      this.setState(this.state);
      this.formWasUpdated(this.state.form);
    };
  },
  updateCustomer(key) {
    return (customer) => {
      if (customer) {
        this.state.form[key] = customer.id;
        this.state.selectedCustomer = customer;
      } else {
        this.state.form[key] = null;
        this.state.selectedCustomer = null;
      }
      this.setState(this.state);
      this.formWasUpdated(this.state.form);
    };
  },
  blur({ key, required }) {
    return (e) => {
      const hasValue = this.state.form[key];
      if (required && !hasValue) {
        this.state.errors[key] = true;
      } else {
        this.state.errors[key] = false;
      }
      this.setState(this.state);
    };
  },
  toggle(field) {
    return (e) => {
      this.state.isShowingAddress[field.key] = !this.state.isShowingAddress[field.key];
      this.setState(this.state);
    };
  },
  lookupAddressById(key) {
    return (e) => {
      this.state.matches[key] = LOADING;
      this.setState(this.state);
      LookupAddressApi.lookupById(e.target.value).then((match) => this.state.matches[key] = match).catch((_) => this.state.matches[key] = NO_RESULTS_FOUND).then((_) => this.setState(this.state));
    };
  },
  fillAddress(key, { external_id, address }) {
    return (e) => {
      const form = this.state.form;
      form[`${key}_name`] = external_id;
      form[`${key}_address_line_1`] = address.address_line_1;
      form[`${key}_address_line_2`] = address.address_line_2;
      form[`${key}_city`] = address.city;
      form[`${key}_state`] = address.state;
      form[`${key}_postal_code`] = address.postal_code;
      this.state.isShowingAddress[key] = true;
      this.state.matches[key] = void 0;
      this.setState(this.state);
      this.formWasUpdated(this.state.form);
    };
  },
  render() {
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h3", { className: "load-detail__section-header" }, "Load Details"), /* @__PURE__ */ React.createElement("div", { className: "form dynamic_form" }, viewFields({
      props: this.props,
      state: this.state,
      actions: {
        update: this.update,
        lookupAddressById: this.lookupAddressById,
        fillAddress: this.fillAddress,
        toggle: this.toggle,
        blur: this.blur,
        updateCustomer: this.updateCustomer
      }
    })));
  }
});
